import Page_Login from 'page/login/index';
import Page_Setup from 'page/setup/index';
import Page_Inbox from 'page/inbox/index';
import Page_Dashboard from 'page/dashboard/index';
import Page_Survey_Responses from 'page/survey_results/index';
import Page_Feedback from 'page/feedback/index';
import Page_Project from 'page/project/index';
import Page_Account from 'page/account/index';
import Page_Billing from 'page/account/billing';
import Page_Referral from 'page/account/referral';
import Page_Api_Token from 'page/account/api_token';
import Page_Connected_App from 'page/account/connected_app';
import Page_Extension_Key from 'page/account/extension_key';
import Page_Branding from 'page/account/branding';
import Page_Member from 'page/member/index';
import Page_Plan from 'page/plan/index';
import Page_Integration from 'page/integration/index';
import Page_Feedback_Viewer from 'page/viewer/index';
import Page_Integration_Log from 'page/account/integration_log';
import Page_Loading from 'page/loading/index';

export default {
    'login'                       : Page_Login,
    'setup'                       : Page_Setup,
    'demo'                        : 'demo/index', // lazy load
    'inbox'                       : Page_Inbox,
    'dashboard'                   : Page_Dashboard,
    'response'                    : Page_Survey_Responses,
    'feedback'                    : Page_Feedback,
    'feedback_design'             : Page_Feedback,
    'project'                     : Page_Project,
    'style_guide'                 : 'style_guide/index', // lazy load
    'account'                     : Page_Account,
    'billing'                     : Page_Billing,
    'referral'                    : Page_Referral,
    'api_token'                   : Page_Api_Token,
    'connected_app'               : Page_Connected_App,
    'extension_key'               : Page_Extension_Key,
    'integration_log'             : Page_Integration_Log,
    'branding'                    : Page_Branding,
    'member'                      : Page_Member,
    'member_restricted'           : 'member/restricted', // lazy load
    'session_replay'              : 'session_replay/index', // lazy load
    'user_segment'                : 'user_segment/index', // lazy load
    'plan'                        : Page_Plan,
    'integration'                 : Page_Integration,
    'loading'                     : Page_Loading,
    '404'                         : '404/access_denied',
    'access_denied'               : '404/access_denied',
    'admin'                       : 'admin/index', // lazy load
    'portal'                      : 'portal/index', // lazy load
    'viewer'                      : Page_Feedback_Viewer,
    'sr'                          : 'session_replay/share', // lazy load
    'capture'                     : 'capture/index' // lazy load
};
